// extracted by mini-css-extract-plugin
export default {"wrapper":"styles_wrapper__adN5E","container":"styles_container__OYrH+","errorText":"styles_errorText__zMu1F","input":"styles_input__aLM9L"};